export default {
  backgroundColor: "#1A1A1A",
  fontColor: "#ffffff"
};
